"use client"

import { Columns2 } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `Columns2Icon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const Columns2Icon = component(Icon)({ as: Columns2 })
